var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProviderLate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 881"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 1",
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#CF2020",
    fillOpacity: 0.25
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M65.7465 49.6046L65.1455 50.3681C65.2921 50.4754 65.3206 50.6772 65.2094 50.8186L65.0437 51.0291L64.9249 51.1798L64.7592 51.3904C64.648 51.5318 64.4388 51.5593 64.2923 51.452L63.6913 52.2153C63.58 52.3567 63.3709 52.3843 63.2243 52.277L62.9912 52.1062L64.1611 50.62L64.2799 50.4692L65.4498 48.983L65.6829 49.1539C65.8293 49.2616 65.8579 49.4632 65.7465 49.6046Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M57.1162 41.0205L52.7227 46.6053C52.5215 46.8609 52.5734 47.2255 52.8384 47.4197L61.2491 53.5776C61.514 53.7717 61.892 53.7216 62.0932 53.466L66.4868 47.8812C66.688 47.6255 66.6361 47.2609 66.3711 47.0668L57.9604 40.9089C57.6954 40.7149 57.3175 40.7648 57.1162 41.0205Z",
    fill: "#2B2B2B"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M53.7099 46.8887L57.6641 41.8617L65.4965 47.5957L61.5423 52.6226L53.7099 46.8887Z",
    fill: "#58ACF5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M61.4692 51.5005L64.3867 47.7916",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M60.7094 50.9861L63.627 47.2772",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M59.9536 50.4718L62.8711 46.7631",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M59.1977 49.9574L62.1152 46.2487",
    stroke: "white",
    strokeWidth: 0.5,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M38.8142 84.7012L31.3502 82.8896L32.1777 80.5059L32.2637 80.252L35.673 81.3627C35.6821 81.4442 35.8687 81.8892 35.8308 81.9787C38.0064 82.375 38.8312 83.9729 38.8142 84.7012Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M35.8262 81.9797C35.8262 81.9797 35.3088 81.9956 35.1802 82.4388",
    stroke: "#353535",
    strokeWidth: 0.6715,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M36.6914 82.1896C36.6914 82.1896 36.174 82.2054 36.0454 82.6486",
    stroke: "#353535",
    strokeWidth: 0.6715,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M31.3981 82.6349L38.8145 84.4348",
    stroke: "#353535",
    strokeWidth: 0.6715,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M31.7501 81.6566C31.7501 81.6566 32.8171 81.9322 32.6126 82.9148",
    stroke: "#353535",
    strokeWidth: 0.6715,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M58.6094 84.6125L50.913 84.6589L51.0963 82.1515L51.1139 81.8849L54.7029 82.1379C54.7328 82.2145 55.0287 82.6005 55.0154 82.6963C57.2243 82.555 58.4371 83.9034 58.6094 84.6125Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M55.0195 82.6968C55.0195 82.6968 54.5226 82.8369 54.513 83.2971",
    stroke: "#353535",
    strokeWidth: 0.6715,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M55.9082 82.6917C55.9082 82.6917 55.4113 82.8318 55.4016 83.2919",
    stroke: "#353535",
    strokeWidth: 0.6715,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M50.8959 84.4023L58.543 84.3544",
    stroke: "#353535",
    strokeWidth: 0.6715,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M50.9891 83.3667C50.9891 83.3667 52.0936 83.3762 52.1504 84.3767",
    stroke: "#353535",
    strokeWidth: 0.6715,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M54.993 41.8034C54.993 41.8034 56.4041 55.5334 56.4126 60.6584C56.4211 65.7834 56.3889 82.2282 56.3889 82.2282L50.0776 82.2911C50.0776 82.2911 49.7161 66.5551 49.6753 63.3776C49.6346 60.2001 46.0962 48.6188 46.0962 48.6188L45.5497 44.3039L45.4268 42.6626L45.4676 41.6985L54.993 41.8034Z",
    fill: "#58ACF5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M48.4004 43.6751C48.4004 43.6751 46.2575 56.3908 44.5895 61.2567C42.9213 66.1225 36.7898 81.8077 36.7898 81.8077L31.3461 80.2522C31.3461 80.2522 36.0432 63.424 37.0436 60.3965C38.044 57.3689 37.3099 47.1011 39.3956 40.6764C39.6952 39.7534 40.0026 36.8522 40.0026 36.8522L41.328 39.1824L39.3956 40.6764L48.4004 43.6751Z",
    fill: "#58ACF5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M40.25 41.4958C39.2062 45.9041 38.8081 54.3302 38.4032 59.4901C38.2452 61.3605 32.2976 80.2561 32.2976 80.2561",
    stroke: "#2E84C8",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M47.6277 50.4952C47.6277 50.4952 50.5479 59.3135 50.5723 61.5319C50.5966 63.7503 51.1914 82.2281 51.1914 82.2281",
    stroke: "#2E84C8",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M62.8816 42.5332C62.8816 42.5332 63.7414 44.2061 63.4797 44.8191C63.2181 45.432 62.9191 46.4778 62.7322 46.3697C62.5452 46.2615 62.3957 44.7768 62.3957 44.4554C61.7976 44.1701 60.938 43.4735 60.938 43.4735L62.8816 42.5332Z",
    fill: "#C88876"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M51.7003 20.5509C51.7003 20.5509 54.2988 22.1578 55.1059 22.8906C56.4515 24.1124 57.3982 31.479 57.8467 32.633C58.2953 33.7868 62.2325 40.3444 63.4785 42.3236C60.9368 44.7352 60.2391 45.2352 60.2391 45.2352C60.2391 45.2352 56.7277 41.5224 54.5576 36.1205C52.4373 30.8425 50.9193 36.1205 50.9193 36.1205H48.709C48.709 36.1205 48.7606 36.8835 48.1953 35.9534C47.6299 35.0232 47.6299 35.0232 47.6299 35.0232L49.0242 28.8758L49.6233 26.987L49.6731 22.9729L51.0188 21.2449L51.7003 20.5509Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M48.6778 47.3877L49.3756 53.2212C49.3756 53.2212 55.5555 53.2389 57.25 52.5026C56.9491 49.5053 56.4258 44.487 55.9277 39.748C55.6681 37.2784 55.4155 34.8849 55.2048 32.8929C54.8823 29.8437 54.6583 27.7352 54.6583 27.7352L47.4816 37.2827L48.6778 47.3877Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M55.8457 38.9723C55.7669 38.0341 55.6814 37.0964 55.5906 36.159L55.3061 33.3487L54.9973 30.5408C54.8923 29.605 54.7797 28.6701 54.6644 27.7354C54.7476 28.6732 54.8335 29.6109 54.9268 30.5479L55.2119 33.3582L55.5141 36.1668C55.619 37.1023 55.7291 38.0376 55.8457 38.9723Z",
    fill: "#2B2B2B"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M51.7001 13.0429C52.326 12.2781 52.4928 10.1849 51.0324 9.9434C50.3648 9.78242 50.0728 10.3863 49.4469 9.9434C48.821 9.50054 48.1951 10.1726 48.0282 10.4204C47.8614 10.668 47.2772 10.7361 46.86 10.4204C46.4427 10.1046 46.0255 10.9096 45.8587 11.1913C45.6918 11.473 45.817 10.6277 45.2328 10.9901C44.6486 11.3523 43.3964 13.0028 45.0657 15.2972C46.8185 16.6256 48.4214 16.7534 48.4214 16.7534L50.0313 15.4347L51.7001 13.0429Z",
    fill: "#1A1C1C"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M51.6974 13.043C51.6974 13.043 52.3619 18.8063 49.4187 18.8063C47.1789 18.8063 46.199 17.1511 46.1573 16.5601C45.1604 16.2958 44.6459 14.7738 45.564 14.5323C46.1899 14.3311 46.5236 15.1965 46.5236 15.1965C46.5236 15.1965 46.8295 14.4384 46.8715 13.5127C47.6223 13.7541 51.141 13.9158 51.6974 13.043Z",
    fill: "#C88876"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M46.1561 16.5601C46.1561 16.5601 46.1561 17.7461 46.1561 18.3911C46.1561 19.0361 46.0176 19.6709 45.0839 19.7864C45.608 20.9475 48.7851 30.5034 48.7851 30.5034L49.7196 24.0486L50.6914 21.6827L50.5419 20.1644C50.5419 20.1644 49.4888 19.9928 49.3457 19.3968C49.2026 18.8008 49.3083 18.1277 49.3083 18.1277L46.1561 16.5601Z",
    fill: "#C88876"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M49.9222 22.0292C49.9222 22.0292 49.1339 23.3645 46.5831 22.0292C45.8917 23.6687 46.1905 25.1424 46.1905 25.1424L46.6828 25.764C46.6828 25.764 48.9083 27.7545 49.6233 26.2724C50.3131 24.8421 51.1113 26.5863 50.3131 24.8421C49.3662 22.7726 50.1986 22.8907 50.1986 22.8907L49.9222 22.0292Z",
    fill: "#58ACF5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M45.6685 19.5988C45.6685 19.5988 48.9531 24.4249 48.9531 28.0181C48.9531 29.3646 48.9267 29.3199 48.7282 30.7316C48.295 33.8117 49.0642 38.4482 49.0153 42.8116C48.9678 47.0485 48.7728 51.0538 48.3964 53.2211C42.6985 53.7982 39.3992 53.5817 36.825 52.7883C37.017 47.3794 37.4654 36.9842 38.0635 33.5274C38.6618 30.0705 45.6685 19.5988 45.6685 19.5988Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_9"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M39.1899 45.5962C39.2104 45.4114 39.2722 44.7599 39.2722 44.7599L39.3885 44.4733L39.7477 44.2341C39.7069 44.1182 40.3479 43.4738 40.3479 43.4738L41.6155 44.4197C41.6155 44.4197 43.5421 47.1225 43.2826 47.8209C43.1571 48.1822 42.276 47.3129 42.1267 46.9593C42.142 47.6903 43.1173 49.2386 43.0622 49.6844C43.0282 49.9896 42.7386 50.0311 42.2801 49.5697C42.4842 50.0611 41.721 49.8989 41.4348 49.4284C41.5371 49.8072 40.9431 49.6123 40.7021 49.225C40.6509 49.2662 40.592 49.29 40.4276 49.2419C39.9031 49.088 38.9864 47.4275 39.1899 45.5962Z",
    fill: "#C88876"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M42.2773 49.5697C42.0827 49.1857 41.8859 48.8095 41.7067 48.425C41.5259 48.0406 41.3679 47.6512 41.2351 47.2434C41.2621 47.6723 41.4027 48.0887 41.5827 48.479C41.7687 48.8677 41.9923 49.241 42.2773 49.5697Z",
    fill: "#C88876"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M41.4316 49.4283C41.343 49.2684 41.263 49.1071 41.1821 48.947C41.1037 48.7857 41.0243 48.6253 40.9539 48.4611C40.8067 48.1349 40.6827 47.8016 40.5487 47.4625C40.5777 47.8247 40.6821 48.1787 40.8289 48.5129C40.9803 48.8444 41.1698 49.1656 41.4316 49.4283Z",
    fill: "#C88876"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M40.7012 49.2248C40.5642 48.9455 40.4202 48.6787 40.2881 48.4056C40.1544 48.1326 40.0372 47.8582 39.9347 47.5657C39.9308 47.877 40.0316 48.1818 40.1651 48.4613C40.3041 48.7394 40.4758 49.0036 40.7012 49.2248Z",
    fill: "#C88876"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M45.666 19.5988C45.666 19.5988 39.8181 21.1997 39.1077 22.0292C38.3974 22.8586 34.9058 31.7427 34.9882 32.0786C35.0709 32.4145 34.0962 36.3129 34.0962 36.3129C34.0962 36.3129 37.2945 46.1654 37.6435 46.6941C39.1386 46.3576 42.9235 44.7915 42.9235 44.7915C42.9235 44.7915 40.1045 35.9924 40.0048 35.0134C39.9052 34.0345 42.4468 29.3199 42.4468 29.3199",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M34.3951 36.8139C34.8968 38.4727 35.3904 40.134 35.918 41.7854L36.7127 44.2619L37.1243 45.4962L37.3396 46.1108C37.418 46.3163 37.482 46.5161 37.592 46.7242L37.6102 46.7585L37.6536 46.7484C38.1154 46.6409 38.5623 46.4965 39.0071 46.3471C39.4514 46.1965 39.8929 46.0391 40.3317 45.8755C41.2098 45.5489 42.0812 45.2076 42.9481 44.854L43.0059 44.8303L42.9873 44.7718L41.7452 40.8597C41.3355 39.5544 40.9294 38.248 40.5439 36.9361L40.2637 35.9504C40.2189 35.7857 40.1753 35.6208 40.1343 35.4553C40.0972 35.2905 40.0493 35.1226 40.0416 34.9609C40.0511 34.633 40.1718 34.3025 40.2803 33.9826C40.395 33.6612 40.525 33.3446 40.6579 33.029C41.1976 31.7697 41.8091 30.5384 42.4439 29.3199C41.7896 30.5291 41.1584 31.7507 40.5972 33.0046C40.4578 33.3184 40.3259 33.6356 40.2089 33.9587C40.098 34.2833 39.9732 34.6067 39.9603 34.9629C39.9684 35.1422 40.0155 35.3061 40.0518 35.474C40.092 35.6405 40.1347 35.8064 40.1785 35.9718L40.4526 36.9609C40.8297 38.2761 41.227 39.5855 41.6281 40.8936C42.0319 42.2009 42.4323 43.5094 42.8539 44.8115L42.8931 44.7295C42.03 45.0859 41.1606 45.4308 40.2859 45.7606C39.8487 45.9258 39.4089 46.0846 38.9671 46.2366C38.5252 46.3873 38.0799 46.533 37.6278 46.6403L37.6892 46.6646C37.5949 46.4879 37.5208 46.2744 37.4443 46.0753L37.2255 45.4636L36.8062 44.233L35.9957 41.7623L34.3951 36.8139Z",
    fill: "#2B2B2B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M39.1043 22.0293C39.3115 22.1385 39.5114 22.2573 39.7041 22.385C39.8949 22.515 40.0828 22.649 40.252 22.8027C40.422 22.9551 40.5778 23.1215 40.7105 23.3048C40.8381 23.4913 40.9351 23.6958 40.998 23.9163C40.9747 23.6888 40.8924 23.4674 40.7733 23.2664C40.6506 23.0669 40.4907 22.8923 40.3173 22.7341C40.1415 22.5778 39.9477 22.4425 39.7439 22.3248C39.5402 22.2082 39.3283 22.1036 39.1043 22.0293Z",
    fill: "#2B2B2B"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M48.9238 34.6713C48.1927 29.5159 44.2278 25.764 44.2278 25.764L45.0847 23.7241L42.9208 22.6408L43.8399 20.1296L46.0857 19.0132C46.0857 19.0132 46.0098 19.4037 45.6631 19.5989C45.6631 19.5989 45.6631 20.8154 47.8885 25.7304C48.3912 28.412 48.9078 31.6911 48.9238 34.6713Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_15"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M45.502 20.2532C43.7774 21.6762 43.3728 24.6263 44.6093 26.3878",
    stroke: "#2B2B2B",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_16"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M45.3926 25.6404C45.7089 26.0911 45.5867 26.7039 45.1195 27.0092C44.6523 27.3144 44.017 27.1965 43.7006 26.7458C43.3843 26.2951 43.5065 25.6821 43.9737 25.3769C44.4411 25.0716 45.0762 25.1897 45.3926 25.6404Z",
    fill: "#2C96E5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M44.9574 25.927C45.0362 26.1748 44.9449 26.3978 44.7718 26.509C44.6002 26.6223 44.3522 26.6216 44.1426 26.4593C44.1809 26.5851 44.2993 26.6914 44.4428 26.7306C44.5863 26.7732 44.7521 26.746 44.88 26.6631C45.0071 26.5791 45.0947 26.4407 45.1069 26.2965C45.1224 26.1536 45.0642 26.008 44.9574 25.927Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M49.8242 19.9197C49.8242 19.9197 49.05 23.5157 49.0216 27.8862C48.8205 30.8912 48.9515 35.5018 48.9515 35.5018C48.9515 35.5018 49.7516 26.609 51.6992 25.2748C50.9182 24.2652 53.2168 23.1833 53.2168 23.1833L52.3636 22.1737L51.6992 20.5509L49.296 19.0916C49.3578 19.5592 49.4403 19.7215 49.8242 19.9197Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M50.822 20.9733C51.215 22.0557 51.5283 21.7768 51.8359 25.3842",
    stroke: "#2B2B2B",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M48.8835 26.538C48.939 27.6497 48.9569 28.7623 48.9679 29.875L48.9834 33.2131C48.9768 35.4386 48.9757 37.6643 48.9546 39.8897C48.9278 42.1154 48.9299 44.3407 48.8538 46.5641C48.8217 47.676 48.78 48.7878 48.7121 49.898C48.6448 51.0082 48.563 52.1183 48.4027 53.2208C48.5099 52.6738 48.585 52.1212 48.651 51.5681C48.7171 51.0147 48.7737 50.4605 48.8169 49.9051C48.9044 48.7945 48.9724 47.6826 49.0183 46.5697C49.1037 44.3439 49.1336 42.1169 49.1391 39.8909C49.1456 37.6646 49.1528 35.4384 49.1186 33.2124C49.0838 30.9869 49.0548 28.7588 48.8835 26.538Z",
    fill: "#2B2B2B"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M49.3977 26.2973C49.3977 26.2973 51.2162 24.1624 52.1602 22.8347C51.3929 22.3274 50.4248 21.5844 50.4248 21.5844L51.7003 20.5509L49.2971 19.0916L51.031 20.4248L50.3216 21.4344L50.4085 22.0295L51.1254 22.8047L49.2202 25.1306",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M48.9492 28.0183C48.0591 26.4507 43.5854 22.9728 43.5854 22.9728L45.2863 21.6622L43.4537 20.2486L46.0869 19.0132L45.5672 19.4691V20.0403L46.125 20.7213C46.125 20.7213 45.9462 20.8593 46.1893 21.4022C46.4322 21.9452 46.9556 22.9728 46.9556 22.9728L48.052 24.3011",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M48.9434 28.0183C48.6313 27.4925 48.2045 27.0412 47.7798 26.5982C47.3501 26.1578 46.9009 25.7352 46.442 25.3235C45.5228 24.5011 44.5778 23.7061 43.6058 22.9413L43.6056 23.0044C44.1759 22.5716 44.7443 22.1364 45.3072 21.6945L45.349 21.6617L45.3072 21.6295C45.0015 21.3942 44.6918 21.1641 44.3824 20.9332C44.0745 20.7005 43.7594 20.4768 43.4478 20.2485C43.7472 20.4915 44.0429 20.7387 44.3459 20.9772C44.6473 21.2175 44.9482 21.4586 45.2534 21.6943V21.6293C44.6823 22.0612 44.1168 22.4999 43.5531 22.9407L43.5127 22.9724L43.5531 23.0041C44.5234 23.7666 45.4803 24.5473 46.4046 25.3622C46.8655 25.7708 47.3211 26.1853 47.758 26.6181C48.1892 27.0541 48.6226 27.4977 48.9434 28.0183Z",
    fill: "#2B2B2B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M48.9516 28.0181C49.4479 27.1318 49.9637 26.2558 50.4907 25.387C50.7549 24.9529 51.0259 24.5227 51.3071 24.0993C51.5875 23.6756 51.8733 23.2538 52.1954 22.861L52.2246 22.8255L52.186 22.7996C51.5943 22.4036 51.0213 21.979 50.4558 21.5479L50.4568 21.6198C50.6671 21.4451 50.8797 21.2727 51.0875 21.095C51.2959 20.918 51.5002 20.7363 51.7012 20.5508C51.477 20.7097 51.2563 20.8725 51.0396 21.04C50.8221 21.2068 50.6097 21.3789 50.3948 21.5487L50.3488 21.585L50.3957 21.6206C50.9649 22.051 51.5396 22.4735 52.1362 22.8696L52.1267 22.8083C51.8024 23.2072 51.5176 23.6311 51.2387 24.0575C50.9624 24.4857 50.6966 24.9198 50.438 25.3576C49.9178 26.2314 49.4282 27.122 48.9516 28.0181Z",
    fill: "#2B2B2B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_21"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M40.0059 35.0138C39.7424 34.8057 39.3915 34.7062 39.047 34.7062C38.8744 34.7092 38.7005 34.73 38.5381 34.7861C38.3732 34.8338 38.2233 34.9188 38.0872 35.0138C38.25 34.9666 38.4064 34.9193 38.5669 34.8916C38.7258 34.8593 38.8869 34.8465 39.0474 34.8457C39.2083 34.8424 39.3689 34.8601 39.5288 34.8878C39.6882 34.9178 39.8479 34.9562 40.0059 35.0138Z",
    fill: "#2B2B2B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M40.0059 34.6415C39.8797 34.3806 39.6441 34.1716 39.3689 34.0477C39.2309 33.9862 39.0814 33.9454 38.9296 33.9374C38.7786 33.9214 38.6268 33.9486 38.4858 33.989C38.6343 34.0024 38.7762 34.0129 38.9132 34.0453C39.0503 34.0736 39.1828 34.1161 39.3081 34.1744C39.435 34.2292 39.5551 34.2988 39.6712 34.3771C39.7855 34.4576 39.8987 34.5431 40.0059 34.6415Z",
    fill: "#2B2B2B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M51.3629 30.6511C50.6186 30.7206 50.404 30.3558 50.3428 29.9517C50.3428 29.9517 49.3559 25.6982 51.6222 25.406C53.1414 25.2046 53.7972 26.0117 54.3086 29.4441C54.4428 30.3446 53.6709 30.4463 53.5778 30.4526",
    stroke: "#2B2B2B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M51.954 30.5648C51.9706 30.7883 51.7962 30.9825 51.5646 30.9983C51.3329 31.0143 51.1317 30.8461 51.1153 30.6227C51.0988 30.3993 51.273 30.205 51.5046 30.1892C51.7361 30.1731 51.9374 30.3414 51.954 30.5648Z",
    fill: "#2C96E5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M53.7274 30.4417C53.744 30.6651 53.5696 30.8595 53.3381 30.8753C53.1063 30.8913 52.9051 30.7231 52.8887 30.4997C52.8721 30.2761 53.0465 30.082 53.278 30.0661C53.5098 30.0499 53.711 30.2182 53.7274 30.4417Z",
    fill: "#2C96E5"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_24",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M49.2832 18.8038C48.9821 18.7966 48.6878 18.7442 48.4068 18.6578C48.1272 18.5685 47.8564 18.4541 47.6106 18.2991C47.5472 18.2635 47.4901 18.2185 47.4294 18.1788C47.368 18.1396 47.3106 18.0955 47.256 18.048L47.0876 17.9099C47.0366 17.8587 46.9841 17.8086 46.931 17.7588C46.721 17.5565 46.5461 17.3238 46.3659 17.0896C46.4325 17.2195 46.502 17.3497 46.5785 17.476C46.6685 17.5932 46.7436 17.7231 46.8481 17.8307C47.037 18.0634 47.2792 18.2512 47.5327 18.4171C47.7921 18.5764 48.0793 18.6935 48.3773 18.761C48.526 18.7956 48.678 18.8152 48.8294 18.8277C48.9817 18.8307 49.1345 18.832 49.2832 18.8038Z",
    fill: "#C88876"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_25"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M51.1582 13.9747C51.0642 13.8855 50.9452 13.815 50.8106 13.7826C50.6769 13.747 50.5292 13.7524 50.3946 13.7953C50.1221 13.8838 49.9299 14.1157 49.8672 14.3613C50.04 14.1694 50.2202 14.0062 50.4433 13.936C50.6644 13.8598 50.9083 13.8944 51.1582 13.9747Z",
    fill: "#1A1C1C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_26",
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M49.77 14.8032C49.7218 14.9694 49.6928 15.1412 49.6949 15.3165C49.6934 15.4043 49.7038 15.4929 49.7248 15.5829C49.7484 15.6705 49.782 15.7689 49.8805 15.8417C49.9064 15.8564 49.9359 15.8684 49.9637 15.8795L50.0093 15.8967C50.0364 15.9127 50.0618 15.9313 50.0798 15.9578C50.1186 16.0083 50.1329 16.0806 50.1211 16.1499C50.0989 16.2928 49.9485 16.3984 49.7666 16.4036C49.8523 16.428 49.9493 16.428 50.0412 16.3925C50.1318 16.3548 50.2067 16.2745 50.2376 16.1788C50.2708 16.0837 50.2586 15.9733 50.2019 15.881C50.174 15.8341 50.1292 15.7979 50.0815 15.7696C50.0568 15.7573 50.0306 15.7484 50.0049 15.7385C49.9931 15.7311 49.9817 15.7266 49.9693 15.7208C49.922 15.6914 49.8873 15.6198 49.8651 15.546C49.8399 15.4721 49.8266 15.391 49.8145 15.3091C49.7924 15.1447 49.7807 14.9752 49.77 14.8032Z",
    fill: "#CE727D"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M48.9877 16.9788C49.1521 17.0284 49.4456 17.1031 49.8475 17.1497C49.9761 17.1646 50.0472 17.3023 49.9802 17.4094C49.7737 17.7392 49.5352 17.8983 49.1685 17.8476C48.8131 17.7986 48.705 17.3865 48.7621 17.107C48.7822 17.0079 48.8879 16.9487 48.9877 16.9788Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_27"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M49.1719 14.4299C49.1126 14.2558 48.9415 14.1338 48.7715 14.0608C48.5981 13.984 48.4067 13.9479 48.2146 13.9486C48.0228 13.9512 47.8279 13.9972 47.6626 14.0936C47.4956 14.1869 47.3656 14.3296 47.2822 14.4874C47.5446 14.2363 47.8696 14.0951 48.2171 14.0969C48.3888 14.0934 48.562 14.1197 48.7283 14.1683C48.8924 14.221 49.0602 14.2877 49.1719 14.4299Z",
    fill: "#1A1C1C"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_28"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M48.8087 15.1308C48.8528 15.3057 48.7413 15.4818 48.56 15.5243C48.3787 15.5667 48.1962 15.4592 48.1521 15.2843C48.1081 15.1093 48.2195 14.9333 48.4009 14.8908C48.5822 14.8485 48.7649 14.9558 48.8087 15.1308Z",
    fill: "#1A1C1C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_29"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M49.0332 15.0768C49.0307 14.9568 48.9448 14.8537 48.8542 14.777C48.7613 14.698 48.6454 14.6423 48.5195 14.621C48.394 14.6009 48.2576 14.6238 48.1512 14.6917C48.0438 14.7589 47.9728 14.8597 47.9226 14.9633C48.0062 14.8806 48.0869 14.7999 48.1877 14.7537C48.2879 14.7094 48.3969 14.6941 48.504 14.7125C48.6116 14.7285 48.7147 14.7742 48.8092 14.8333C48.9017 14.8944 48.9921 14.9689 49.0332 15.0768Z",
    fill: "#1A1C1C"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_30"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M51.0945 14.9234C51.1101 15.0963 50.9774 15.2488 50.7982 15.2638C50.619 15.2788 50.4608 15.1508 50.4454 14.978C50.4297 14.8051 50.5624 14.6525 50.7416 14.6376C50.9208 14.6225 51.0788 14.7505 51.0945 14.9234Z",
    fill: "#1A1C1C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_31"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M51.0566 14.5676C51.0184 14.4959 50.9381 14.4475 50.8535 14.4294C50.7679 14.4102 50.6777 14.4231 50.5957 14.4521C50.5163 14.4875 50.4437 14.5417 50.3985 14.6138C50.3531 14.6854 50.3328 14.7683 50.3407 14.8473C50.3711 14.7735 50.4064 14.7074 50.456 14.6545C50.5049 14.6017 50.5632 14.5581 50.6314 14.5345C50.6967 14.5043 50.7704 14.4944 50.843 14.497C50.9164 14.5004 50.9898 14.5216 51.0566 14.5676Z",
    fill: "#1A1C1C"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProviderLate);
export default __webpack_public_path__ + "static/media/ProviderLate.0fde4603562a9b5243f54e365aee4bc7.svg";
export { ForwardRef as ReactComponent };